import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Code } from "@modules/codes/types";
import { CodeFormValues } from "@modules/codes/validations";
import { editCodeService } from "./service";
import { UseEditCodeMutationOptions } from "./types";

export function useEditCodeMutation(
  options?: UseEditCodeMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Code, ApiError, { id: string; data: CodeFormValues }>({
    mutationFn: ({ id, data }) => editCodeService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("limited_code_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
